// LineChart.js
import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,
  props: ['data', 'options'],
  mounted () {
    /*
    let div = document.createElement('div')
    div.innerText = (this.data * 100).toFixed(0) + ' %'
    div.setAttribute('class', 'label');
    div.setAttribute('style', 'font-size:' + Math.min(this.width/4, 26) + 'px')
    this.$el.appendChild(div)
    */   
    
    this.renderChart(this.buildData(), this.buildOptions())
  },
  methods: {
    buildData() {
      let color = this.data < 1 ? '#E53935' : '#43A047'
      let builtData = {
        datasets: [{
            data: [this.data, Math.max(0, 1 - this.data)],
            backgroundColor: [color, '#E0E0E0'],
            borderWidth: [0, 0]
        }],
    
        // These labels appear in the legend and in the tooltips when hovering different arcs
        labels: [
            'Done',
            'Todo',
        ]
      }
      
      return builtData
    },
    buildOptions() {
      let builtOptions = {
        cutoutPercentage: 85,
        responsive: false,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        plugins: {
					datalabels: {
            display: false,
          }
				},
      }
      this.$lodash.merge(builtOptions, this.options)
      return builtOptions
    }
  },
  watch: {
    data: function() {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      this.renderChart(this.buildData(), this.buildOptions())
    }
  }
}
